<div class="vendor-profile-container">
  <div class="navigation-breadcrumb">
  <span class="breadcrumb-text" (click)="navigateToVendorDashboard()">
    {{ vendorList.vendorProfile }}
  </span>
  </div>
  <div class="vendor-profile">
    <h1 class="title">{{ vendorName }} </h1>
    <div class="top-section">
      <app-contractor-vendor-head-count></app-contractor-vendor-head-count>
      <app-interviews-status></app-interviews-status>
    </div>
    <div class="quarterly-feedback-section">
      <h2 class="section-heading">{{ VendorProfile.quarterlyFeedback }}</h2>
      <app-quarterly-feedback></app-quarterly-feedback>
    </div>
    <div class="vendor-info-section">
      <h2 class="section-heading">{{ VendorProfile.vendorInfo }}</h2>
      <app-vendor-info></app-vendor-info>
    </div>
  </div>
</div>
